import React , {useCallback , useEffect} from 'react'
import Header from '../../../Layouts/Components/Header'
import CustomButton from '../../shared/CustomButton'
import MatchingForm  from './MatchingForm'
import MatchingView from './MatchingView'
import { Grid , Box } from '@mui/material'
import { getMessageTypes , ResetMatching , getRules } from "../state/matchingAction";
import { useSelector , useDispatch } from "react-redux";
import useSnackBar from "../../Hooks/useSnackBar";
import ScreenLoader from '../../shared/ScreenLoader'
import { useNavigate , useParams } from "react-router-dom";
const MatchingDetails = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const {matchingId} = useParams()
  const { success, error, snackbar } = useSnackBar();
  
  const loadMessageType = useCallback(() => dispatch(getMessageTypes(error)), [error,dispatch]);
  const loadRules = useCallback (() =>dispatch(getRules(error)),[dispatch,error])

 
  const { messageTypes , fieldsP1 , fieldsP2 , orginalMessagePart1 , orginalMessagePart2 , Rules } = useSelector((state) => state.matchingRules);

 
  useEffect(() => {   
    loadMessageType()
    loadRules()
    
    
  }, [loadMessageType,loadRules,dispatch]);



  let currentRule = ''
if(matchingId === "add-rule") 
{
  currentRule = {
    id:"",
      ruleName: "",
      messageId1: null,
      way1: "",
      messageId2: null,
      way2: "",
      matchingRuleFields: [
          {
              filedId1: null,
              elementId1: null,
              fieldId2: null,
              elementId2: null,
              mandatory: null,
              operator:''
          },
         
      ]
  
  }
}else {
   currentRule = Rules.length > 0 ? Rules?.filter((rule) => rule.id == matchingId)[0] : {}

}
  
console.log(currentRule)

  return (
    <>
    {snackbar}
{ messageTypes?.length > 0 && Object.keys(currentRule).length > 0   ?   <>
      <Header headLine="Matching rules">
   <CustomButton text="Create New Rule"  type="add" action={() =>{
         navigate('/rules/add-rule')
   }}/>
   </Header>
   <Box 
    sx={{
     backgroundColor: "#F8FAFB",
    
     paddingBottom: "30px",
   }}
   >
<Grid container>
     <Grid item xs={6} >
     <MatchingForm
     messageTypes = {messageTypes}
     fieldsP1={fieldsP1}
     fieldsP2={fieldsP2}
     success={success}
     error={error}
     CurrentRule={currentRule}
     />
     </Grid>
     <Grid item xs={6} sx={{backgroundColor:"#fff", padding:"50px 30px 0 30px"}}>
     <MatchingView orginalMessagePart1={orginalMessagePart1} orginalMessagePart2={orginalMessagePart2} />
     </Grid>
   </Grid>
   </Box>
   
 </> : <ScreenLoader/>}
</>
  )
}

export default MatchingDetails